import { Navigate } from "react-router-dom";

const LandingRoute = () => {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Logged in → ProtectedRoute will decide dashboard or setup
  return <Navigate to="/dashboard" replace />;
};

export default LandingRoute;
